type CustomVideoOptions = Pick<
  Partial<HTMLVideoElement>,
  'muted' | 'autoplay' | 'playsInline'
>;

const DEFAULT_VIDEO_OPTIONS: CustomVideoOptions = {
  muted: true,
  autoplay: true,
  playsInline: true,
};
/**
 * Creates video element for provided tracks
 * @param tracks - tracks
 * @param customVideoOptions - to provide custom video options like muted, autoplay, ...
 * @param _MediaStream - Internal parameter for Dependency Injection [DO NOT USE]
 * @returns - html video element that plays the same tracks.
 *
 * @public
 */
export const createVideoElementFromTracks = (
  tracks: MediaStreamTrack[],
  customVideoOptions?: CustomVideoOptions,
  _MediaStream = MediaStream,
): HTMLVideoElement => {
  const mediaStream = new _MediaStream(tracks.map((track) => track.clone()));
  const videoEl = document.createElement('video');
  videoEl.srcObject = mediaStream;
  const videoOptions: CustomVideoOptions = {
    ...DEFAULT_VIDEO_OPTIONS,
    ...customVideoOptions,
  };

  for (const option in videoOptions) {
    const optionKey = option as keyof typeof videoOptions;
    const value = videoOptions[optionKey];

    if (value !== undefined) {
      videoEl[optionKey] = value;
    }
  }
  return videoEl;
};
